import {
    MimaButton,
    MimaDateInput,
    MimaDropdown,
    MimaInput,
    MimaText,
    Modal,
    ReceiptCheckBox as RCB,
} from '../../components';
import styles from '../../assets/styles/Transactions/Transactions.module.scss';
import { Formik } from 'formik';
import React, { useState } from 'react';
import moment from 'moment';
import { amountFormatter } from '../../utils/utils';
import { NewInvoiceContainer } from '../../containers';
import { AnimatePresence } from 'framer-motion';
import { transactionStore } from '../../stores';

const Tag = ({
    closeModal,
    selectedIncome,
    tags,
    invoiceDetailsList,
    balInvoiceList,
    loading,
    validationSchema,
    onSubmit,
}) => {

    const [showTag, setShowTag] = useState(true);
    const [receiptModal, setReceiptModal] = useState(false);
    const [inflowTypeData, setInflowTypeData] = useState("");
    const goBack = () => {
        if (receiptModal) {
            setReceiptModal(false);
            setShowTag(true);
        } else {
            closeModal();
        }
    }

    return (
        <div>
            <Modal closeModal={closeModal} goBack={goBack}>
                {showTag && (
                    <div>
                    <MimaText variant="subtitle" color="var(--color-primary)" align="center" mb={4}>
                        Transaction Details
                    </MimaText>
                    <Formik
                        initialValues={{
                            inflowType: "",
                            incomeType: "",
                            hasInvoice: true,
                            invoiceId: "",
                            invoiceDetails: "",
                            balanceInvoiceDetails: "",
                        }}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}>
                        {({
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            values,
                            errors,
                            touched,
                        }) => (
                            <div>
                                <MimaText labelTitle="Date and Time" mb={1}>{moment(selectedIncome.createdAt).format("DD/MM/YYYY HH:mm a")}</MimaText>
                                <MimaText labelTitle="Narration" mb={1}>{selectedIncome.narration}</MimaText>
                                <MimaText labelTitle="Amount" mb={1}>{amountFormatter(selectedIncome.currencyCode).format(
                                    selectedIncome.transactionAmount || 0,
                                )}</MimaText>

                                <MimaDropdown
                                    labelTitle="Tag"
                                    placeholder="Select Tag"
                                    name="inflowType"
                                    currentValue={values.inflowType}
                                    id="inflowType"
                                    onChange={data => {
                                        setFieldValue('inflowType', data.key);
                                        transactionStore.setTag(selectedIncome)
                                    }}
                                    data={tags}
                                    mt={2}
                                    error={errors.inflowType}
                                    touched={touched.inflowType}
                                />
                                {
                                    values.inflowType === "Income" && (
                                        <>
                                            <div className={styles.checks}>
                                                <RCB
                                                    title="New Income"
                                                    id="newIncome"
                                                    name="incomeType"
                                                    onChange={() => {
                                                        setFieldValue('incomeType', 'newIncome');
                                                    }}
                                                    checked={values.incomeType === 'newIncome'}
                                                    value="newIncome"
                                                />
                                                <RCB
                                                    title="Balance Existing Payment"
                                                    onChange={() => {
                                                        setFieldValue('incomeType', 'balanceIncome');
                                                    }}
                                                    checked={values.incomeType === 'balanceIncome'}
                                                    id="balanceIncome"
                                                    name="incomeType"
                                                    value="balanceIncome"
                                                />
                                            </div>
                                            {values.incomeType === "newIncome" && (
                                                <>
                                                    <MimaText width={40}>Have you created an invoice for this payment?</MimaText>
                                                    <div className={styles.checks}>
                                                        <RCB
                                                            title="YES"
                                                            onChange={() => {
                                                                setFieldValue('hasInvoice', true);
                                                            }}
                                                            checked={values.hasInvoice}
                                                            value={true}
                                                            name="hasInvoice"
                                                        />
                                                        <RCB
                                                            title="NO"
                                                            onChange={() => {
                                                                setFieldValue('hasInvoice', false);
                                                                setReceiptModal(true);
                                                                transactionStore.setTag(selectedIncome)
                                                                setInflowTypeData(values.inflowType)
                                                                setShowTag(false)
                                                            }}
                                                            checked={!values.hasInvoice}
                                                            value={false}
                                                            name="hasInvoice"
                                                        />
                                                    </div>
                                                </>
                                            )}

                                            {(values.incomeType === "newIncome" && values.hasInvoice === true) && (
                                                <>
                                                    <MimaDropdown
                                                        labelTitle="Invoice Details"
                                                        placeholder="Select Invoice"
                                                        name="invoiceDetails"
                                                        currentValue={values.invoiceDetails}
                                                        id="invoiceDetails"
                                                        onChange={data => {
                                                            setFieldValue('invoiceId', data.key);
                                                            setFieldValue("invoiceDetails", data.values)
                                                        }}
                                                        data={invoiceDetailsList}
                                                        mt={2}
                                                        error={errors.invoiceDetails}
                                                        touched={touched.invoiceDetails}
                                                        width={40}
                                                    />
                                                </>
                                            )}
                                            {values.incomeType === "balanceIncome" && (
                                                <>
                                                    <MimaDropdown
                                                        labelTitle="Tag Transaction Details"
                                                        placeholder="Select Invoice"
                                                        name="balanceInvoiceDetails"
                                                        currentValue={values.balanceInvoiceDetails}
                                                        id="balanceInvoiceDetails"
                                                        onChange={data => {
                                                            setFieldValue('balanceInvoiceDetails', data.value);
                                                            setFieldValue('invoiceId', data.key);
                                                        }}
                                                        data={balInvoiceList}
                                                        mt={2}
                                                        error={errors.balanceInvoiceDetails}
                                                        touched={touched.balanceInvoiceDetails}
                                                        width={40}
                                                    />
                                                </>
                                            )}
                                        </>
                                    )
                                }
                                <MimaButton
                                    title="Save"
                                    onClick={handleSubmit}
                                    type="submit"
                                    loading={loading}
                                    variant="form"
                                    mt={2}
                                    width={40}
                                />
                            </div>
                        )}
                    </Formik>
                </div>
                )}
                {receiptModal && (
                    <NewInvoiceContainer
                        closeModal={closeModal}
                        inflowTypeData={inflowTypeData}
                        setInflowTypeData={setInflowTypeData}
                    />
                )}
            </Modal>

        </div>

    );
};

export default Tag;
